import React, { createContext, useState } from "react";
import { ReactComponent as ClosePopup } from "../assets/images/icons/close.svg";

export const ModalWindowContext = createContext(null);

export default function ModalWindowProvider({ children }) {
  const [options, setOptions] = useState({
    title: "",
    confirmButtonLabel: "Yes",
  });

  const [isOpen, setIsOpen] = useState(false);
  const [promise, setPromise] = useState(null);

  const { onConfirm, confirmButtonLabel, title, message } = options;

  function modalWindow(options) {
    setOptions(options);
    setIsOpen(true);
    return new Promise(resolve => {
      setPromise({ resolve });
    });
  }

  async function handleConfirm() {
    if (typeof onConfirm === "function") {
      try {
        await onConfirm();
        promise?.resolve(true);
        setIsOpen(false);
      } catch (err) {
        console.error(err?.message);
      }
    } else {
      promise?.resolve(true);
      setIsOpen(false);
    }
  }

  function handleCancel() {
    setIsOpen(false);
    promise?.resolve(false);
  }

  return (
    <ModalWindowContext.Provider value={{ modalWindow, handleCancel }}>
      {children}
      {isOpen ? (
        <div className="modal-window">
          <div
            className="modal-window__overlay"
            onClick={handleCancel}
            role="presentation"></div>
          <div className="modal-window__wrapper">
            <header className={"modal-window__header"}>
              <h3 className="modal-window__title">{title}</h3>
            </header>
            <div className={"modal-window__message"}>{message}</div>
            <div className={"modal-window__footer"}>
              <button
                className={"modal-window__button-cancel"}
                onClick={handleCancel}>
                <ClosePopup />
              </button>
              {confirmButtonLabel && (
                <button
                  className={"input-submit input-submit__primary"}
                  onClick={handleConfirm}>
                  {confirmButtonLabel}
                </button>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </ModalWindowContext.Provider>
  );
}
